/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Err_Debt_On_Defect_ShelfInputs */

const vi_product_lot_err_debt_on_defect_shelf = /** @type {(inputs: Product_Lot_Err_Debt_On_Defect_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không dùng lô ở kệ hàng lỗi để bù nợ lô.`)
};

/**

* @param {Product_Lot_Err_Debt_On_Defect_ShelfInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_err_debt_on_defect_shelf = /** @type {((inputs?: Product_Lot_Err_Debt_On_Defect_ShelfInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Err_Debt_On_Defect_ShelfInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_err_debt_on_defect_shelf(inputs)
});